export const h = {		
	login:{		
			login:"로그인",
			pleaseusername:"사용자 이름을 입력하세요",
			pleasepassword:"비밀번호를 입력 해주세요",
			checkname:"올바른 사용자 이름을 입력하세요",
			checkpass:"비밀번호는 3자 이상이어야 합니다.",
		},	
	navbar:{	
		home:"첫 장",
		mycenter:"개인 센터",
		outlogin:"그만두다",
		close:"폐쇄",
		editLanguage:"편집 언어",
	},	
	vip:{	
		nickname:"닉네임",
		pleasenickname:"닉네임을 입력해주세요",
		username:"사용자 이름",
		pleaseusername:"사용자 이름을 입력하세요",
		arealogin:"로그인 영역",
		pleasearealogin:"로그인 영역을 입력해주세요",
		nationality:"시민권 국가",
		pleasenationality:"국적을 선택해주세요",
		depositstatus:"입금현황",
		pleasedepositstatus:"입금상태를 선택해주세요",
		createtime:"생성 시간",
		logintime:"로그인 시간",
		startime:"시작 시간",
		endtime:"종료 시간",
		no:"일련번호",
		shangji:"상사에게 직접 추천",
		keyongmoney:"사용 가능한 잔액",
		baozhengjing:"여유",
		fudongyingkui:"유동손익",
		zicantotal:"총 자산",
		yaoqingma:"초대 코드",
		zongrujing:"총 입금액",
		zongchujing:"총 인출",
		loginIp:"로그인 아이피",
		zuihoulogin:"마지막 로그인 시간",
		shoucirujingmoney:"첫 입금액",
		shoucirujingtime:"첫 입금 시간",
		kaitongtime:"영업시간",
		keyong:"사용 가능",
		daoshi:"가정 교사",
		dongjie:"꼭 매달리게 하다",
		chujingstate:"출금현황",
		xiajichujingstate:"하위 탈퇴 현황",
		caozuo:"작동하다",
		chakan:"확인하다",
		heji:"총",
		moneytotal:"전체 균형",
		paixu:"종류",
		daochu:"내보내다",
		huiyuanguanli:"회원관리",
		yonghu:"사용자",
		search:"쿼리 검색",
		reset:"초기화",
		delete:"삭제",
		kickout:"내 보내 ~",
		notlogin:"로그인하지 않았습니다",
		editLanguage:"편집 언어",
		yourujing:"보증금이 있습니다",
		wurujing:"보증금 없음",
    todayreg: "오늘의 등록량: ",
    newvipnum: "새로운 VIP 회원 가입 수: ",
    juese: "역할",
    xiugaimima: "비밀번호 변경",
    jiumima: "이전 비밀번호",
    shurujiumima: "이전 비밀번호를 입력하세요",
    xinmima: "새로운 비밀번호",
    shuruxinmima: "새로운 비밀번호를 입력하세요",
    gerenzhongxing: "개인 센터",
    yonghuxinxi: "사용자 정보"
	},	
	info:{	
		home:"홈페이지",
		user:"사용자 ID",
		nickname:"닉네임",
		account:"계정",
		identity:"ID 번호",
		phone:"전화 번호",
		nationality:"시민권 국가",
		Balance:"잔액관리",
		real:"실계좌",
		zhongmongy:"전체 균형",
		keyongmoney:"사용 가능한 잔액",
		jiaoyidongjie:"거래가 동결되었습니다",
		shishilirun:"실시간 이익",
		shishikeyong:"실시간으로 이용 가능",
		xunizhanghu:"가상계좌",
		churujinguanli:"입출금 관리",
		chakanzijinjilu:"펀드 내역 보기",
		rujinjilu:"입금기록",
		rujinjine:"입금 금액",
		jiaoyibishu:"거래수",
		chujinjilu:"출금기록",
		chujinjine:"출금금액",
		jiaoyiguanli:"거래관리",
		lishijilu:"역사 기록",
		chakanlishi:"과거 거래 정보 보기",
		jiaoyishoushu:"거래 제비",
		jiaoyiyingkui:"거래손익",
		dangqianchicang:"현재 위치",
		chakandangqianchicang:"현재 위치 정보 보기",
		dangqianguadan:"현재 대기 중인 주문",
		chakanguadanliebiao:"대기 주문 목록 보기",
		guadanbishu:"대기 중인 주문 수",
		yongjinguanli:"커미션 관리",
		duanwei:"계급",
		wu:"없음",
		zhishushangji:"직속 상사",
		shangjidaili:"우수한 에이전트",
		xiajituandui:"하위팀",
		shurudailiname:"에이전트 이름을 입력하세요.",
		chakan:"확인하다",
		fanyongjie:"리베이트 금액",
		fanyongbishu:"리베이트 수",
		chakanyongjinjilu:"리베이트 기록 보기",
		chakanyonghuinfo:"사용자 세부정보 보기",
		chakanwenjuan:"설문지 보기",
		resetpassword:"암호를 재설정",
		sendmsg:"문자 보내",
		update:"개정하다",
		unbound:"구속되지 않음",
		weishiming:"실명인증 불가",
		gendan:"문서 관리",
		gensui:"따르다",
		chakangendan:"주문 기록 보기",
		dingdanhao:"주문 번호",
		shoudongpay:"수동충전",
		chakanyongjingjilu:"커미션 내역 보기",
		xiugaiyonghuxinxi:"사용자 정보 수정",
		queding:"확신하는",
		quxiao:"취소",
		email:"우편",
		selguoji:"국적을 선택해주세요",
		sendusermsg:"사용자에게 메시지 보내기",
		title:"제목",
		shurutitle:"메시지 제목을 입력해주세요",
		content:"콘텐츠",
		shurucontent:"메시지 내용을 입력해주세요",
		zhenshi:"현실",
		xuni:"가상",
		fangxiang:"방향",
		zhanghu:"계정",
		add:"증가하다",
		less:"빼다",
		type:"유형",
		guanliyuanpay:"관리자 재충전",
		pay:"충전하다",
		money:"양",
		updategdmsg:"주문 정보 수정",
		xinhaoyuan:"신호 소스",
		yes:"예",
		no:"아니요",
		updateyongjingmsg:"커미션 정보 수정",
		qingxuanzejuese:"계정 역할을 선택하세요.",
		zuoduo:"오래 가세요",
		zuokong:"짧은",
		gensuinicheng:"닉네임 팔로우",
		kaicangjia:"개장 가격",
		pingcangjia:"종가",
		shousu:"로트 규모",
		pingcangdate:"포지션 개시일",
		kaicangdate:"마감일",
		chakangensuiinfo:"팔로우 세부정보 보기",
		gensuiuserno:"사용자 번호 팔로우",
		gensuiyonghuname:"사용자 닉네임을 팔로우하세요",
		gensuifangshji:"방법을 따르다",
		number:"수량",
		danwei:"단위",
		zhengxiang:"앞으로",
		fanxaing:"뒤집다",
		beishu:"다수의",
		shousu:"로트 규모",
		gensuizhuangtai:"상태를 따르다",
		genjinzhong:"신청은 다음과 같습니다",
		gensuiok:"팔로우하는 데 동의합니다.",
		gensuino:"팔로우를 거부함",
		chexiao:"취소",
		gensuidate:"시간을 따르다",
		chakanlishijiaoyi:"과거 거래 정보 보기",
		chakanguadanlist:"대기 주문 목록 보기",
		heyue:"계약",
		daili:"연기",
		huiyuanname:"회원 이름",
		xianjia:"가격 제한",
		zhisun:"손실을 막다",
		guadanjia:"대기 주문 가격",
		zhiyingzhisun:"이익을 얻고 손실을 막으세요",
		zhiyingjia:"이익실현 가격",
		zhiyinghuichejia:"이익 되돌림 가격",
		zhisunjia:"손실 중지 가격",
		zhisunhuichejia:"손실 되돌림 가격 중지",
		weiset:"설정되지 않음",
		zt:"상태",
		chakanchicangmsg:"현재 위치 정보 보기",
		shouyiId:"수취인 ID",
		xiajiid:"하위 사용자 ID",
		xiajiuser:"하위 사용자 이름",
		fanyongmonney:"리베이트 금액",
		tuihuibaozhengjing:"보증금 반환",
		shouxufei:"수수료",
		shouyi:"소득",
		lixi:"관심",
		zengmoney:"보너스",
		zhuijiabaozhengjing:"마진콜",
		fanyong:"할인",
		rujing:"보증금",
		chujing:"자금 인출",
		chujingshibai:"출금심사 실패시 환불",
		guanliyuanless:"관리자 공제",
		pingzhong:"다양성",
		shengqingzhong:"지원",
		wancheng:"마치다",
		chongzhimima:"비밀번호 재설정 성공",
		copy:"복사",
		zhanghaomima:"계정 비밀번호",
		fenye:"기사/페이지",
    tixianmima:"비밀번호 인출",
		gong:"흔한",
		tiao:"조각",
		ye:"페이지",
		goto:"이동",
		outtitle:"로그아웃되었습니다. 취소하고 이 페이지에 머물거나 다시 로그인할 수 있습니다.",
		outok:"로그아웃해도 괜찮습니다",
		chongxingdenglu:"재등록",
		cancel:"취소",
		pingtai:"플랫폼",
		nodata:"데이터 없음",
    shangjiID: "상급 ID",
    shangjiaccount: "상급 계정",
    shangjiname: "상급 닉네임",
    shangjinickname: "상급 성명",
    zhongyingkui: "총 손익",
    fuying: "부유 수익",
    yue: "잔액",
    sheng: "오름차순",
    jiang: "내림차순"
	},	
	history:{		
			guadan:"이익과 손실",
			shijia:"보류 중인 주문",
			gendan:"시장 가격",
			dangqianjia:"주문 따르기",
			geyelixi:"현재 가격",
			weituodate:"하룻밤 이자",
			pingcangfangshi:"커미션 시간",
			dingdanyongjing:"결산방법",
			shoudongpingcang:"주문 수수료",
			qiangzhipingcang:"수동 폐쇄",
			gendanpingcang:"강제청산",
			baocang:"청산",
			yuguqiangpingjia:"포지션을 청산하려면 주문을 따르세요.",
			kaicangdiqu:"예상 강제 패리티 가격",
			ispingcang:"개방면적",
			tips:"강제청산이 확실합니까?",
			pincangsucc:"힌트",
			queding:"포지션이 성공적으로 마감되었습니다",
			cancel:"확신하는",
		},	
	Langswitch: {	
	  "en":"영어",	
	  "id":"인도네시아 인",	
	  "th":"태국어",	
	  "vi":"베트남어",	
	  "zh":"중국인",	
	  "fa":"프랑스 국민",	
	  "han":"한국인",	
	  "tu":"터키 사람",	
	  "pu":"포르투갈 인",	
	  "xi":"스페인의",	
	  "jp":"일본어",	
	  "ar":"아라비아 말",	
	},	
}		



// WEBPACK FOOTER //
// ./src/i18n/langs/han.js